/**
 * @generated SignedSource<<862f70705d4defa5d5bddd59fc11be87>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "assetId"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "assetId"
                }
            ],
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "asset",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "disabledDate",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AssetSystemInfoUpdateModalQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AssetSystemInfoUpdateModalQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "3d8858622c43c1aa2a61aa09e49c3d7c",
            "id": null,
            "metadata": {},
            "name": "AssetSystemInfoUpdateModalQuery",
            "operationKind": "query",
            "text": "query AssetSystemInfoUpdateModalQuery(\n  $assetId: ID!\n) {\n  asset(id: $assetId) {\n    color\n    disabledDate\n    id\n  }\n}\n"
        }
    };
})();
node.hash = "41eadccbc6dabe6f8d6b80c95f1e3efd";
export default node;
